import { ContainerConfig } from '../../containers/types';

const getContainerCacheKey = (containerConfig: ContainerConfig): string =>
  `${containerConfig.type}-${containerConfig.id}`;

export default getContainerCacheKey;
